import { render, staticRenderFns } from "./chat-user-list.vue?vue&type=template&id=72bf2c8f&scoped=true"
import script from "./chat-user-list.vue?vue&type=script&lang=js"
export * from "./chat-user-list.vue?vue&type=script&lang=js"
import style0 from "./chat-user-list.vue?vue&type=style&index=0&id=72bf2c8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bf2c8f",
  null
  
)

export default component.exports